import React, { useRef, useEffect } from 'react';
import LoadableDeviationPage from '../../DeviationPage/LoadableDeviationPage';
import { getStreamItemId } from '../redux/helpers';
export var DuperbrowsePageWrapper = function (_a) {
    var isDuperbrowseActive = _a.isDuperbrowseActive, currentItem = _a.currentItem, children = _a.children, isLoading = _a.isLoading, justClosedAStream = _a.justClosedAStream;
    // on navigation, scroll back top
    var lastItemId = useRef();
    var currentItemId = currentItem && getStreamItemId(currentItem);
    useEffect(function () {
        // we do not want to scroll if we just returned from a nested stream
        // or if we don't have a current item (duper is inactive)
        // or if we are just re-rendering without a change to the current item
        if (!justClosedAStream &&
            currentItemId &&
            currentItemId !== lastItemId.current) {
            window.scrollTo(0, 0);
        }
        lastItemId.current = currentItemId;
    }, [currentItemId, justClosedAStream]);
    return (React.createElement(React.Fragment, null, isDuperbrowseActive ? (React.createElement(LoadableDeviationPage, { deviation: currentItem, isWholePageLoading: isLoading })) : (children)));
};
DuperbrowsePageWrapper.displayName = 'DuperbrowsePageWrapper';
export default DuperbrowsePageWrapper;
//# sourceMappingURL=DuperbrowsePageWrapper.js.map